import { toast } from 'sonner';
import {
  usePersonTrainingModules,
  useAssignTrainingModule,
} from '../../../../hooks/onboardingOps';
import { AssignItemList } from '../../../../components/onboarding/AssignItemList';
import { ApiError } from '../../../../lib/api';

/**
 * Pick the e-learning modules the new starter must complete. Anything the
 * role template already assigned arrives pre-ticked, so this step is usually
 * a glance and a Next.
 */
export function TrainingStep({ personId }: { personId: string }) {
  const modules = usePersonTrainingModules(personId);
  const set = useAssignTrainingModule(personId);

  async function toggle(moduleId: string, assigned: boolean) {
    try {
      await set.mutateAsync({ moduleId, assigned });
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Could not update');
    }
  }

  return (
    <AssignItemList
      items={modules.data}
      loading={modules.isLoading}
      pending={set.isPending}
      emptyTitle="No training modules"
      emptyDescription="Build e-learning under Onboarding, Training modules, then come back."
      onToggle={(id, assigned) => void toggle(id, assigned)}
    />
  );
}
